export const materialBlockTypes = {
  heading: "標題", concept: "觀念", example: "例題", question: "練習題", image: "附圖", unclassified: "待確認",
};

export const materialBlockMarkdown = (block) => {
  if (!["question", "example"].includes(block.type) || !block.question) return String(block.markdown || "");
  return [block.question.prompt_md || block.markdown,
    block.question.answer_md && `答案：\n${block.question.answer_md}`,
    block.question.solution_md && `詳解：\n${block.question.solution_md}`].filter(Boolean).join("\n\n");
};

export const materialMarkdown = (document) => (document?.blocks || []).map((block) =>
  [block.title && `## ${block.title}`, materialBlockMarkdown(block)].filter(Boolean).join("\n\n")).join("\n\n---\n\n");

export function moveMaterialBlock(blocks, sourceId, targetId) {
  const source = blocks.findIndex((block) => block.id === sourceId);
  const target = blocks.findIndex((block) => block.id === targetId);
  if (source < 0 || target < 0 || source === target) return blocks;
  const result = [...blocks]; const [block] = result.splice(source, 1); result.splice(target, 0, block);
  return result;
}

export const materialQuestionTransfer = (document) => (document?.blocks || [])
  .filter((block) => ["question", "example"].includes(block.type) && block.question)
  .map((block) => materialBlockMarkdown(block)).join("\n\n---\n\n");

// Persist the receipt before uploading; the same file reuses it after an uncertain response.
export const materialReceiptKey = (authToken) => {
  let hash = 2166136261;
  for (const char of String(authToken || "")) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
  return `material-upload-receipts-v1:${hash >>> 0}`;
};
export const readMaterialReceipts = (key) => {
  try { const value = JSON.parse(window.sessionStorage.getItem(key) || "[]"); return Array.isArray(value) ? value : []; } catch { return []; }
};
export const persistMaterialReceipts = (key, receipts) => {
  try { window.sessionStorage.setItem(key, JSON.stringify(receipts)); } catch { /* Server receipts remain authoritative. */ }
};
export const fileFingerprint = async (file) => {
  if (!window.crypto?.subtle) throw new Error("目前瀏覽器不支援安全檔案識別，請使用 HTTPS 或 localhost。");
  const digest = await window.crypto.subtle.digest("SHA-256", await file.arrayBuffer());
  return Array.from(new Uint8Array(digest), (value) => value.toString(16).padStart(2, "0")).join("");
};

export const newMaterialRequestId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  if (!window.crypto?.getRandomValues) throw new Error("目前瀏覽器無法建立工作識別，請使用新版瀏覽器。");
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
